import React, { useState } from 'react';
import Collapsible from 'react-collapsible';

export const ProjectCardBody = ({ projectTitle, projectDescriptionList, projectDate, projectLink }) => {

    const projects = [
        {
            "title": "QNA RAG, Conversational Knowledge Retrieval from PDFs",
            "date": "[04/2024 - 05/2024]",
            "description": [
                "Developed a conversational interface using Streamlit, Chroma DB, PyPDF2, HuggingFace embeddings, and Python to facilitate user interaction.",
                "Implemented PDF processing and text-to-vector conversion for efficient document handling and retrieval, utilizing HuggingFace embeddings and storing vectors in the vector database.",
                "Designed a conversational retrieval chain leveraging the Mistralai version 0.2 model for providing relevant responses to user queries."
            ],
            "github_link": "github.com/mohitkumarrajbadi/QNA-RAG"
        },
        {
            "title": "Grab A Cycle",
            "date": "[01/2023 - 02/2023]",
            "description": [
                "Built a Social Media Decentralized Web Application for 5th Semester Minor Project",
                "Utilized React, SCSS, Bootstrap, Solidity, Hardhat, Alchemy, MetaMask"
            ],
            "github_link": "github.com/mohitkumarrajbadi/grab_a_cycle"
        },
        {
            "title": "Social Media DApp",
            "date": "[03/2020 - 05/2020]",
            "github_link": "github.com/mohitkumarrajbadi/social_media_app"
        },
        {
            "title": "SCA Student Resource",
            "date": "[01/2019 - 03/2019]",
            "github_link": "github.com/mohitkumarrajbadi/sca-study-resource-management"
        }
    ];

    return (
        <>
            <div className='json-heading-wrapper'>
                [
                <div className="json-ui">
                    {projects.map((project, index) => (
                        <div key={index} className="json-project">
                            <span>&#123;</span>
                            <div className="json-property">
                                <span className="json-key">"title":</span> <span className="json-value">"{project.title}"</span>,
                            </div>
                            <div className="json-property">
                                <span className="json-key">"date":</span> <span className="json-value">"{project.date}"</span>,
                            </div>
                            {project.description && (
                                <div className="json-property display-inline-block">
                                    <span className="json-key">"description":</span>
                                    <span className="json-value">[</span>
                                    <ul className="json-array">
                                        {project.description.map((desc, index) => (
                                            <li key={index} className="json-array-item">"{desc}"{index < project.description.length - 1 && ","}</li>
                                        ))}
                                    </ul>
                                    <span className="json-value">],</span>
                                </div>
                            )}
                            <div className="json-property">
                                <span className="json-key">"github_link":</span> <span className="json-value">"{project.github_link}"</span>
                            </div>
                            <span>&#125;{index < projects.length - 1 && ","}</span>
                        </div>
                    ))}
                </div>
                ]
            </div>
        </>
    )
}

export default ProjectCardBody;
